import { render, staticRenderFns } from "./PopUpViewMessagesByUsers.vue?vue&type=template&id=4c8749c1"
import script from "./PopUpViewMessagesByUsers.vue?vue&type=script&lang=js"
export * from "./PopUpViewMessagesByUsers.vue?vue&type=script&lang=js"
import style0 from "./PopUpViewMessagesByUsers.vue?vue&type=style&index=0&id=4c8749c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports